export default "__VITE_ASSET__DOAIx5_v__"